import { Record } from 'immutable';
import ContentType from '../ContentType';

const ProjectSdgRecord = new Record({
  id: null,
  comments: [],
  sdg_targets: [],
  other: null,
  created: null,
  updated: null,
  project: null,
  sdg: null,
});

class ProjectSdg extends ProjectSdgRecord {
  static contentType = ContentType.PARTNER;

  get id() {
    return this.get('id');
  }
}

export default ProjectSdg;
